import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {materialColorOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {color} from "@cm/graph-v3"

export interface HeightToNormalSockets extends MaterialNodeSockets {
    inputs: {
        color: "color"
    }
    settings: {
        color: "color"
        displacementMax: "float"
        displacementMin: "float"
        displacementNormalStrength: "float"
        displacementNormalSmoothness: "float"
    }
    outputs: {
        color: "color"
    }
}

export const heightToNormalDefinition = {
    exchangeFormat: {
        nodeName: null,
    },
    nodeClass: "HeightToNormal",
    ui: {
        label: "Height to Normal",
        color: "#4987af",
        items: [],
        support: {
            cycles: false,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({color: materialColorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({color: optionalMaterialInput}),
            settings: z.strictObject({
                color: z.optional(color),
                displacementMax: z.optional(z.number()),
                displacementMin: z.optional(z.number()),
                displacementNormalStrength: z.optional(z.number()),
                displacementNormalSmoothness: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<HeightToNormalSockets>
